import * as React from "react";
import { UitkMessagingCard, UitkMessagingCardSection } from "uitk-react-messaging-cards";

/**
 * This is the card that's displayed when no packages are available after applying a filter
 */
interface NoFilteredPackagesAvailableMessageProps {
  headerText: string;
  bodyText: string;
}

export const NoFilteredPackagesAvailableMessage: React.FC<NoFilteredPackagesAvailableMessageProps> = React.memo(
  ({ headerText, bodyText }) => (
    <UitkMessagingCard className="all-y-margin-six">
      <UitkMessagingCardSection heading={headerText}>
        <p className="uitk-type-300">{bodyText}</p>
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  )
);
